const initialState = {
  companyAllUsers: [],
  alertRulesFooter: true,
  showTabEmail: true,
  showTabSms: true,
  switchReply: {
    promoters: true,
    neutral: true,
    detractors: true,
  },
  companyCategories: null,
  myUsers: {
    documents: [],
    total: 0,
  },
  // lang: 'pt',
  country: 'br',
  shortMenu: true,
  hideModules: {
    justifyCenter: false,
    justifyLeft: false,
    justifyRight: false,
    link: false,
    table: false,
    separator: true,
    code: false,
  },
  breakpoints: {
    ' ': 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/settings/initialState.js